import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { linkProps } from '../../../utils/appLink';
import ScrollFadeWrapper from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import LinkWithIconComponent from '../LinkWithIcon/LinkWithIconComponent';
import Image from '../../Image/Image';

const ThreeCardCarGuideMobileComponent = ({ data }) => {
  const { title, description, buttonText, buttonLink, guides = [] } = data;

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100vw',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '40px',
      }}
    >
      {/* Title and Description */}
      <Box sx={{ textAlign: 'center' }}>
        <ScrollFadeWrapper variant="text">
          <Typography
            component="h3"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '2rem',
              lineHeight: '2.25rem',
              letterSpacing: '-0.03em',
              color: '#162F3B',
              mb: '16px',
            }}
          >
            {title}
          </Typography>
        </ScrollFadeWrapper>

        <ScrollFadeWrapper variant="text" delay={0.2}>
          <Typography
            component="p"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: '1.25rem',
              lineHeight: '1.5rem',
              letterSpacing: '-0.03em',
              color: '#162F3B',
              px: '16px',
              alignSelf: 'stretch',
              boxSizing: 'border-box',
              whiteSpace: 'pre-line',
            }}
          >
            {description}
          </Typography>
        </ScrollFadeWrapper>
      </Box>

      {/* Cards */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        {guides.map((guide, index) => (
          <ScrollFadeWrapper key={index} delay={index * 0.1}>
            <Box
              sx={{
                width: '100%',
                backgroundColor: '#FFFFFF',
                borderRadius: '34px',
                boxShadow:
                  '0px 6px 16px 0px #162F3B1F, 0px 1px 2px 0px #A2ACB11F',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
              }}
            >
              {/* Image */}
              <Image
                width={358}
                height={220}
                src={guide.image}
                alt={guide.imgAltTag}
                title={guide.imageAltTitle}
                sx={{
                  width: '100%',
                  height: '220px',
                  objectFit: 'cover',
                  backgroundColor: '#A2ACB1',
                }}
              />

              {/* Card Content */}
              <Box
                sx={{
                  padding: '24px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  flexGrow: 1,
                  gap: '16px',
                }}
              >
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
                >
                  <Typography
                    component="h6"
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 700,
                      fontSize: '1.25rem',
                      lineHeight: '1.5rem',
                      letterSpacing: '-0.03em',
                      color: '#162F3B',
                      textAlign: 'left',
                    }}
                  >
                    {guide.title}
                  </Typography>

                  <Typography
                    component="p"
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: '0.875rem',
                      lineHeight: '1.25rem',
                      letterSpacing: '-0.02em',
                      color: '#162F3B',
                      textAlign: 'left',
                      display: '-webkit-box',
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}
                  >
                    {guide.body}
                  </Typography>
                </Box>

                <Box sx={{ textAlign: 'right' }}>
                  <Link
                    {...linkProps(guide.redirect)}
                    underline="none"
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 600,
                      fontSize: '1rem',
                      lineHeight: '1.5rem',
                      letterSpacing: '-0.02em',
                      color: '#162F3B',
                      '&:hover': {
                        color: '#9EA900',
                        textDecoration: 'underline',
                      },
                    }}
                  >
                    Read More
                  </Link>
                </Box>
              </Box>
            </Box>
          </ScrollFadeWrapper>
        ))}
      </Box>

      {/* Footer */}
      {buttonText && buttonLink && (
        <LinkWithIconComponent
          to={buttonLink}
          iconSize="1rem"
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: '1.5rem',
            letterSpacing: '-0.02em',
            color: '#162F3B',
            textAlign: 'center',
            maxWidth: '343px',
            '&:hover': { color: '#9EA900' },
          }}
        >
          {buttonText}
        </LinkWithIconComponent>
      )}
    </Box>
  );
};

export default ThreeCardCarGuideMobileComponent;
